import Icon, { BaseIconProps } from '../icons/react-components/Icon'
function ShareIcon({ ...props }: BaseIconProps) {
  return (
    <Icon {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlSpace="preserve"
        viewBox="0 0 24 24"
        {...props}
      >
        <path d="M5.6 24c-2.06-.13-3.57-1.83-3.47-3.81v-9.53a1.33 1.33 0 1 1 2.66 0v9.6c-.03.59.37 1.04.88 1.07h12.72c.43-.03.83-.48.8-.99v-9.68a1.33 1.33 0 1 1 2.66 0v9.6c.11 1.9-1.41 3.61-3.38 3.73zm6.4-5.72c-.74 0-1.33-.6-1.33-1.33V4.55L8.14 7.08c-.52.52-1.36.52-1.89 0s-.52-1.36 0-1.89l4.8-4.8c.26-.26.6-.39.95-.39.44-.03.75.17.99.44l4.75 4.75c.52.52.52 1.36 0 1.89-.52.52-1.36.52-1.89 0l-2.52-2.52v12.39c0 .73-.6 1.33-1.33 1.33" />
      </svg>
    </Icon>
  )
}
export default ShareIcon
